import { render, staticRenderFns } from "./10c_doc.vue?vue&type=template&id=26be3af9&scoped=true"
import script from "./10c_doc.vue?vue&type=script&lang=js"
export * from "./10c_doc.vue?vue&type=script&lang=js"
import style0 from "./10c_doc.vue?vue&type=style&index=0&id=26be3af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be3af9",
  null
  
)

export default component.exports